import { CheckoutState } from '../reducers/index';

export const getEnablePaymentConstraintsEmbeddedCheckout = (
    state: CheckoutState,
) => state.app.featureFlags.enablePaymentConstraintsEmbeddedCheckout || false;

export const getEnableStoredPaymentMethods = (state: CheckoutState) =>
    state.app.featureFlags.enableStoredPaymentMethods || false;
